<svelte:options tag={null} />

<script lang="ts">
  import type { BadgeType } from './badge.types';

  export let label: string;
  export let type: BadgeType;

  $: userClass = $$props.class;
  $: attributes = { ...$$restProps };
  $: delete attributes.class;

  function setClasses(type: BadgeType) {
    const classes = ['mc-badge'];

    if (type) {
      classes.push(`mc-badge--${type}`);
    }

    return classes.join(' ');
  }
</script>

<div class="{setClasses(type)} {userClass}" {...attributes}>
  {label}
</div>

<style lang="scss">
  @import '@mozaic-ds/styles/settings-tools/_all-settings';
  @import '@mozaic-ds/styles/components/c.badge';
</style>
